import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";

export const Container = styled.div``;

export const OverlayBottom = styled.div`
  position: absolute;
  inset-block-end: 0;
  z-index: 1;

  inline-size: 100%;
  block-size: 60%;

  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);

  opacity: 0.5;
`;

export const OverlayTop = styled.div`
  position: absolute;
  z-index: 1;

  inline-size: 100%;
  block-size: 75px;

  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #000000 100%);

  opacity: 0.3;
`;

type StyleImageProps = {
  $animationType: string;
};

export const StyledImage = styled(BaseImage, { ...transientOptions })<StyleImageProps>`
  display: flex;
  align-items: center;

  inline-size: 100vw;
  block-size: 100vh;

  transform: scale(1);

  object-fit: cover;

  animation-fill-mode: forwards;
  @keyframes zoomIn {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.2);
    }
  }
  @keyframes penLeft {
    0% {
      transform: translate(0, -83.375px) scale(1.25);
      transform-origin: left top;
    }
    100% {
      transform: translate(-93.75px, -83.375px) scale(1.25);
      transform-origin: left top;
    }
  }
  ${props => {
    switch (props.$animationType) {
      case "zoomIn":
        return css`
          animation: zoomIn 10s linear;
          animation-fill-mode: forwards;
        `;
      case "penLeft":
        return css`
          transform: scale(1.25);

          animation: penLeft 10s linear;
          animation-fill-mode: forwards;
        `;
    }
  }}
  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 100%;
    block-size: 100%;
  }
`;
